import styled from 'styled-components';

import MQ from '../../attrs/mq';

export const Section = styled.div`
  margin: 3rem 0;

  ${MQ.sm`
    margin: 6rem 0;
  `}

  ${MQ.md`
    margin: 8rem 0;
  `}
`;
